import { ReactNode, useEffect } from 'react'
import { useKeyPress } from 'react-use'
import styled from 'styled-components'
import { desktopWidth } from 'ui/src/constants'
import { OverlayBlock } from '../../blocks'

const Modal = styled.div`
    height: 100%;
    left: 0;
    overflow: auto;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 500;
`

const Dim = styled(OverlayBlock)`
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
`

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    margin: 75px auto 0;
    position: relative;
    width: ${desktopWidth}px;
`

type Props = {
    children?: ReactNode
    onCancel: () => void
}

const CreationToolsSourceEditorModal = ({ children, onCancel }: Props) => {
    const [isEscPressed] = useKeyPress((e: KeyboardEvent) => e.key === 'Escape')

    useEffect(() => {
        // disable body scrolling
        document.body.style.overflow = 'hidden'

        return () => {
            // re-enable body scrolling
            document.body.style.overflow = ''
        }
    }, [])

    useEffect(() => {
        if (isEscPressed) {
            onCancel()
        }
    }, [onCancel, isEscPressed])

    const onCloseClick = () => {
        onCancel()
    }

    return (
        <Modal>
            <Dim onClick={onCloseClick} />
            <Wrapper>{children}</Wrapper>
        </Modal>
    )
}

export default CreationToolsSourceEditorModal
